import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--laka-ivory)" }}>
      <Sidebar />
      <MobileNav />
      <main className="lg:pl-64 min-h-screen">
        <div className="px-6 md:px-10 lg:px-14 py-8 md:py-12 max-w-[1400px] mx-auto animate-in fade-in slide-in-from-bottom-4 duration-700 ease-out">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
